"use client";

import { useSectionNavTheme } from "@/app/hooks/useSectionNavTheme";
import { Heading2 } from "../typography";
import { useRef } from "react";
import { PinnedScrollSection } from "../shared";

export const TheResults = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null);

  const achievements = [
    {
      title: "Calculate habitat connectivity in real-time",
      description:
        "across continental scales - the world's first platform enabling instant analysis of environmental impact that previously took days or weeks to complete.",
    },
    {
      title: "Deliver sub-5-second response times",
      description:
        "for complex environmental calculations, enabling interactive project planning and immediate decision-making where landholders previously waited hours for results.",
    },
    {
      title: "Scale to national infrastructure",
      description:
        "providing 24/7 access to scientifically rigorous habitat connectivity analysis for thousands of simultaneous users across Australia's environmental markets.",
    },
    {
      title: "Power Australia's Nature Repair Market",
      description:
        "with the technical foundation that enables landholders to instantly assess project viability and environmental benefits with confidence and precision.",
    },
  ];

  useSectionNavTheme({
    trigger: "#planr-results",
    isDark: true,
    start: "center center",
    end: () => `+=${achievements.length * 500 + window.innerHeight}`,
  });

  return (
    <div
      ref={sectionRef}
      id="planr-results"
      className="pt-20 lg:pb-64 lg:pt-44 relative overflow-hidden"
    >
      {/* Background Blobs */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 right-10 w-96 h-96 bg-haizea-green/30 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-10 w-[500px] h-[500px] bg-haizea-blue/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 right-1/4 w-64 h-64 bg-haizea-orange/25 rounded-full blur-2xl" />
      </div>

      <div className="results-content">
        <div className="max-w-[710px] mx-auto">
          <PinnedScrollSection
            title={
              <Heading2 className="text-slate-600 dark:text-slate-100 lg:max-w-[70vw] mx-auto">
                <span className="text-haizea-green">Our Technology </span>
                enabled PLANR to:
              </Heading2>
            }
            items={achievements}
            contentClassName="lg:h-[40vh]"
            yOffset={110}
            rangeBackground="linear-gradient(90deg, var(--color-haizea-green) 0%, var(--color-haizea-blue) 50%, var(--color-haizea-orange) 100%)"
            titleClassName="font-medium"
            descriptionClassName="text-slate-600 dark:text-slate-300"
            itemClassName="text-slate-700 dark:text-slate-200 my-4"
          />
        </div>
      </div>
    </div>
  );
};
